import { render, staticRenderFns } from "./BtnExcluirRateioRequisicao.vue?vue&type=template&id=0b35f09e"
import script from "./BtnExcluirRateioRequisicao.vue?vue&type=script&lang=js"
export * from "./BtnExcluirRateioRequisicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports